module.exports = __webpack_public_path__ + "images/line_lp/section2-lead-text-bottom-image_58826fce53ed3343f5735ef74432ff7a.png";